;(function ($) {

    const BREAKPOINT = mat_theme.main_menu_breakpoint;
    const SELECTOR = '[data-themescripting="rolldown"]';

    let SCRIPT_HAS_BEEN_ACTIVATED = false;

    const addRolldownActions = () => {

        if (SCRIPT_HAS_BEEN_ACTIVATED) return true;
        SCRIPT_HAS_BEEN_ACTIVATED = true;

        $(SELECTOR).closest('nav').attr('aria-haspopup', true);
        $(SELECTOR).closest('nav').attr('aria-expanded', false);

        // close the menu and make the children non-clickable and non keyboard nav-able
        $(SELECTOR).closest('nav').addClass('closed');

        // toggle the menu
        $(SELECTOR).on('click keypress', function (ev) {
            ev.preventDefault();
            $(this).closest('nav').toggleClass('closed');
            $(this).closest('nav').attr('aria-expanded', (!$(this).closest('nav').hasClass('closed')));
        });

        // Close the nav on escape
        $(SELECTOR).closest('nav').on('keyup', 'a', function (ev) {
            ev.preventDefault();
            if(ev.which == 27){
                $($(this).closest('nav').find(SELECTOR)[0]).trigger('keypress');
            }
        });

    };

    const clearRolldownActions = () => {

        if (!SCRIPT_HAS_BEEN_ACTIVATED) return true;
        SCRIPT_HAS_BEEN_ACTIVATED = false;

        // close the menu and make the children non-clickable and non keyboard nav-able
        $(SELECTOR).closest('nav').removeClass('closed');
        $(SELECTOR).off();

        $(SELECTOR).closest('nav').attr('aria-haspopup', false);
        $(SELECTOR).closest('nav').attr('aria-expanded', false);


    };

    if (window.innerWidth <= BREAKPOINT) {
        addRolldownActions();
    }

    window.addEventListener("resize", function () {
        if (window.innerWidth >= BREAKPOINT) {
            clearRolldownActions();
        } else {
            addRolldownActions();
        }
    });

})(jQuery);